module.exports = __webpack_public_path__ + "img/inHollGray.cd6f6b6f.svg";